// 使用模块 Worker，使 Scanic 依赖由构建工具单独打包并在后台线程加载。
export const createDocumentDetectionWorker = () =>
  new Worker(new URL("./DocumentDetectionWorker.js", import.meta.url), {
    name: "kyc-document-detector",
  });
